<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <PositionsAndOffset />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import PositionsAndOffset from '@/components/settings/parameters/positionsandoffset/PositionsAndOffset'

export default {
  name: 'PositionsAndOffsetView',
  components: {
    PageTitle,
    PageRowWrapper,
    PositionsAndOffset
  }
}
</script>